import React from 'react';
import CaseComponent from '../components/CaseComponent';

const Example: React.FC = () => {
  return (
    <div>
      <CaseComponent />
     </div>
  );
};

export default Example;